<template>
  <div class="container">
    <DialogBox ref="resultDialog"></DialogBox>
        <div class="mainLog">
          <v-container class="top">
            <v-layout align-center justify-center column>
              <img class="logo2" src="../assets/escudo.png" alt="icon">
              <v-card class="card" :loading="loading">
                <v-card-text class="form">
                  <v-container>
                    <v-flex> <!-- xs12 md7 offset-md1-->
                      <div class="login" >
                        <h3>Iniciar sesión</h3>
                        <v-form>
                          <v-text-field v-on:keyup.enter="signIn" type="text" v-model="email" placeholder="Correo"></v-text-field>
                          <v-text-field v-on:keyup.enter="signIn" type="password" v-model="password" placeholder="Contraseña"></v-text-field>
                        </v-form>
                        <v-btn v-on:keyup.enter="signIn" class="toolbar-button" v-on:click="signIn">Entrar</v-btn>
                      </div>
                    </v-flex>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-layout>
          </v-container>
        </div>
        <div class="relleno">

        </div>

  </div>

</template>

<script>
import { Auth } from '../firebase/auth';
import DialogBox from '../components/DialogBox';

export default {
  name: 'login',
  async created() {
    window.bus.$emit('menu/desactivarMenu');

    let user = await Auth.getCurrentUser();

    if(user != null){
      this.$router.replace('/')
    }
  },
  data: function () {
    return {
      loading: false,
      email: '',
      password: ''
    }
  },
  components:{
    DialogBox
  },
  methods: {
    async signIn () {
      
      this.loading = true;

      Auth.signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
              this.$router.replace('/')
          },
          (err) => {
            switch (err.code) {
              case 'auth/invalid-email':
                this.$refs.resultDialog.show('error', "La dirección de correo electrónico está mal formateada.", false);
                break;
              case 'auth/wrong-password':
              case 'auth/user-not-found':
                this.$refs.resultDialog.show('error', "El usuario no existe o la contraseña es incorrecta.", false);
                break;
              default:
                this.$refs.resultDialog.show('error', err.message, false);
                break;
            }
            this.loading = false;  
          }
        )
    }
  }
}
</script>

<style scoped>
  
  @media (min-width: 768px) {
    .container { 
    display: flex;
    }  

    .mainLog {
      flex: 1;
    }

    .relleno {
      float: right;
      display: block;
      margin-right: 277px;
    }
  }

  .logo2 {
    max-width: 50%;
    max-height: 65%;
  }

  .top {
    color: rgba(0, 0, 0, 0.6);
  }

  .card {
    width: 100%;
    margin-top: 24px;
  }

  .form {
    background: #F4F4F4;
  }

  .login {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>